import {BusinessModelResponse} from "@/types/service-response";

export default class BusinessModel {
  private constructor(
      readonly id: number,
      readonly name: string,
      readonly createdAt: string

  ) {}


  static createFromResponse(responseData: BusinessModelResponse): BusinessModel {

    return new BusinessModel(
        responseData.id,
        responseData.name,
        responseData.createdAt,
    )
  }

  static createFromResponseList(responseData: BusinessModelResponse[]): BusinessModel[] {
    return responseData.map((item:BusinessModelResponse) => {
      return new BusinessModel(
          item.id,
          item.name,
          item.createdAt
      )
    })
  }

}